import React from 'react';

const MobileAboutUsPage = () => {
  return (
    <section className="w-full px-4 py-8 mt-8">
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-8 ml-9 text-left">
          <h1
            style={{
              fontFamily: 'Bricolage Grotesque',
              fontWeight: 300,
              fontSize: '36px',
              lineHeight: '32px',
              letterSpacing: '-1%',
            }}
            className="
              text-white
              tracking-tight
              leading-snug
              /* keeps the custom 32 px line‑height on small screens */
              max-w-4xl
            "
          >
            Built By an AI <br />Enthusiast. <br />For AI Founders
          </h1>
        </div>
        <div className="w-full flex justify-center">
          <div
            className="relative rounded-2xl overflow-hidden shadow-2xl"
            style={{
              width: '273px',
              height: '431px',
            }}
          >
            <iframe
              className="absolute inset-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/1EBr0YwgJd4?si=xdNWyYjAl7vPKxUz"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAboutUsPage;